import React, { useState, useEffect } from 'react';
import { useLocation, navigate } from '@reach/router';
import './DashboardBreadCrumbs.scss';
import IcoFont from '@/components/IcoFont';
import { detectPage } from './DashboardBreadCrumbs.data';

interface DashboardBreadCrumbsProps {
  menus: {
    icon: string;
    iconActive: string;
    label: string;
    to: string;
    requiredRoles: string[];
  }[];
}

const DashboardBreadCrumbs: React.FC<DashboardBreadCrumbsProps> = ({ menus }) => {
  const { pathname } = useLocation();
  const [crumbs, setCrumbs] = useState<{ label: string; url: string }[]>([]);

  const handleClickCrumb = (url: string, index: number) => {
    index !== crumbs.length - 1 && navigate(`/dashboard/${url}`);
  };

  useEffect(() => {
    const pathNameSplitted = pathname.split('/');
    const mainPath = pathNameSplitted.length > 3 && pathNameSplitted[2];
    const crumbShouldRender = menus.find((menu) => menu.to === mainPath);
    const beautifyCrumbShouldRender = crumbShouldRender && {
      label: crumbShouldRender?.label,
      url: crumbShouldRender?.to,
    };
    if (beautifyCrumbShouldRender) {
      const currentPage = detectPage.find((page) => page.regex.test(pathname));
      currentPage ? setCrumbs([beautifyCrumbShouldRender, currentPage?.crumb]) : setCrumbs([beautifyCrumbShouldRender]);
    }
  }, [menus, pathname]);

  return (
    <div className="DashboardBreadCrumbs">
      {crumbs.map((crumb, index) => (
        <div
          key={crumb.label}
          className={`DashboardBreadCrumbs-crumb ${index === crumbs.length - 1 && 'lastCrumb'}`}
          onClick={() => handleClickCrumb(crumb.url, index)}
        >
          <span>{crumb.label}</span>
          {index !== crumbs.length - 1 && <IcoFont className="DashboardBreadCrumbs-arrow" icon="curved-right" />}
        </div>
      ))}
    </div>
  );
};

export default DashboardBreadCrumbs;
